import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetQueueStatusRes,
  HealthCheckRes,
  SetQueueStatusReqQuery,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useApp() {
  class App<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Application
     * @name ConnectionCheckControllerConnectionCheck
     * @summary Checking the connection with the application
     * @request GET:/api3/app/connection-check
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    connectionCheckControllerConnectionCheck = (params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/app/connection-check',
        method: 'GET',
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Application
     * @name HealthCheckControllerHealthCheck
     * @summary Health check application
     * @request GET:/api3/app/health-check
     * @response `200` `HealthCheckRes`
     * @response `400` `BaseErrorResponse`
     */
    healthCheckControllerHealthCheck = (params: RequestParams = {}) =>
      this.request<HealthCheckRes, BaseErrorResponse>({
        path: '/api3/app/health-check',
        method: 'GET',
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Queue
     * @name QueueStatusControllerGetQueueStatus
     * @summary Returns queue status
     * @request GET:/api3/app/queue-status
     * @secure
     * @response `200` `GetQueueStatusRes`
     * @response `400` `BaseErrorResponse`
     */
    queueStatusControllerGetQueueStatus = (params: RequestParams = {}) =>
      this.request<GetQueueStatusRes, BaseErrorResponse>({
        path: '/api3/app/queue-status',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Queue
     * @name QueueStatusControllerSetQueueStatus
     * @summary Sets the queue status
     * @request PUT:/api3/app/queue-status
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    queueStatusControllerSetQueueStatus = (data: SetQueueStatusReqQuery, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/app/queue-status',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new App();
}
